// document.addEventListener('DOMContentLoaded', function() {
//   // 只處理 header drawer 裡面、第一層有子選單的 summary
//   const menuDrawer = document.querySelector('#menu-drawer');
//   if (!menuDrawer) return;

//   const parents = menuDrawer.querySelectorAll('summary.js-menu-parent');

//   parents.forEach(function(summary) {
//     const details = summary.closest('details'); // 對應 <details> 包住的那個
//     const toggle = summary.querySelector('.js-menu-toggle'); // 我們加在箭頭上的 class
//     const parentUrl = summary.getAttribute('data-parent-url'); // 父分類要連到哪

//     if (!details || !toggle || !parentUrl) return;

//     // 👉 1. 點「箭頭那塊」：只負責展開 / 關閉子選單
//     toggle.addEventListener('click', function(e) {
//       e.preventDefault();    // 阻止 summary 自己的預設行為
//       e.stopPropagation();   // 避免事件冒泡到 summary

//       const isOpen = details.hasAttribute('open');
//       if (isOpen) {
//         details.removeAttribute('open');
//         summary.setAttribute('aria-expanded', 'false');
//       } else {
//         details.setAttribute('open', '');
//         summary.setAttribute('aria-expanded', 'true');
//       }
//     });

//     // 👉 2. 點「整條 summary 其他區域」：直接去父分類頁面
//     summary.addEventListener('click', function(e) {
//       // 如果點到的是箭頭或箭頭裡面的 SVG，就讓上面的 handler 處理
//       if (e.target.closest('.js-menu-toggle')) return;

//       e.preventDefault(); // 不要展開 / 關閉子選單，直接導航
//       window.location.href = parentUrl;
//     });
//   });
// });

// 文章圖片置中
document.addEventListener('DOMContentLoaded', function () {
  const selectors = [
    'img[src*="MG_7872"]',
    'img[src*="MG_9116"]',
    'img[src*="MG_2390"]',
    'img[src*="IMG_9116"]',
    'img[src*="IMG_9118"]'
  ];

  const images = document.querySelectorAll(selectors.join(','));

  images.forEach(img => {
    const p = img.parentElement;
    if (p && p.tagName.toLowerCase() === 'p') {
      p.style.textAlign = 'center';
      // 或 p.classList.add('caption-center');
    }
  });
});

// 圖片來源間隔拿掉
document.addEventListener('DOMContentLoaded', function () {
  const h5s = document.querySelectorAll('h5');

  h5s.forEach(h5 => {
    if (h5.textContent.includes("An Egyptian signet ring")) {
      h5.style.marginBottom = "8px";
      h5.style.marginTop = "8px";   
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  // 用 selector 找到所有 span，像你之前的寫法
  const selectors = [
    'span'
  ];

  const elements = document.querySelectorAll(selectors.join(','));

  elements.forEach(el => {
    // 用 includes() 比對關鍵字（最穩定）
    if (el.textContent.includes("Mesopotamian seal cylinders")) {

      const parentP = el.closest('p');
      if (parentP) {
        parentP.style.marginBottom = '8px'; 
      }
    }
  });
});


document.addEventListener('DOMContentLoaded', function () {
  const h6s = document.querySelectorAll('h6');

  h6s.forEach(h6 => {
    if (h6.textContent.includes("Image source:")) {
      h6.style.marginTop = "0";
      h6.style.paddingLeft = "80px";
      h6.style.paddingRight = "80px";
    }
  });
});

// 文章頁內main-title 改 36px
document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector('.section-template--18499602972930__main-padding');
  if (section) {
    const title = section.querySelector('.main-page-title');
    if (title) {
      title.style.fontSize = '36px';
    }
  }
});

// 文章內的圖片寬度調整
document.addEventListener('DOMContentLoaded', function () {
  // === 2 張圖片 ===
  const selectorsTwo = [
    'img[src*="MG_7872"]',
    'img[src*="MG_9116"]',
    'img[src*="MG_2390"]',
    'img[src*="IMG_9116"]',
    'img[src*="IMG_9118"]',
    'img[src*="IMG_9119"]',
    'img[src*="IMG_9321"]',
    'img[src*="IMG_9322"]',
    'img[src*="1034776"]',
    'img[src*="MG_0954"]',
    'img[src*="MG_1079"]',
    'img[src*="MG_1111"]'// 新增：讓這張圖也被納入 2 張圖邏輯
  ];

  // === 3 張圖片 ===
  const selectorsThree = [
    'img[src*="MG_7872.jpg"]',
    'img[src*="MG_7698.jpg"]',
    'img[src*="MG_7875.jpg"]'
  ];

  // === 1 張圖片 === width:100%
  const selectorOne = 'img[src*="IMG_9120_1"]';


  const allTwoImages = document.querySelectorAll(selectorsTwo.join(','));
  const allThreeImages = document.querySelectorAll(selectorsThree.join(','));
  const oneImages = document.querySelectorAll(selectorOne);



  // -----------------------------------------
  // 處理 2 張圖片的 <p>
  // -----------------------------------------
  allTwoImages.forEach(img => {
    const parentP = img.closest('p');
    if (!parentP) return;

    const imgsInP = parentP.querySelectorAll('img');
    if (imgsInP.length !== 2) return;

    function desktopLayout() {
      Object.assign(parentP.style, {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '4px',
        flexDirection: 'row'
      });

      imgsInP.forEach(image => {
        // 依照圖片檔名做特例寬度設定
        if (image.src.includes('IMG_9116.jpg')) {
          image.style.width = '48.5%';
        } else if (image.src.includes('IMG_9118.jpg')) {
          image.style.width = '42%';
        } else if (image.src.includes('IMG_9119.jpg')) {
          image.style.width = '59%';
        } else {
          image.style.width = '50%';
        }

        image.style.height = 'auto';
      });
    }

    function mobileLayout() {
      Object.assign(parentP.style, {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        alignItems: 'center'
      });

      imgsInP.forEach(image => {
        image.style.width = '100%';
        image.style.height = 'auto';
      });
    }

    function update() {
      if (window.innerWidth < 768) mobileLayout();
      else desktopLayout();
    }

    update();
    window.addEventListener('resize', update);
  });

  


  // -----------------------------------------
  // 處理 3 張圖片的 <p>
  // -----------------------------------------
  allThreeImages.forEach(img => {
    const parentP = img.closest('p');
    if (!parentP) return;

    const imgsInP = parentP.querySelectorAll('img');
    if (imgsInP.length !== 3) return;

    function desktopLayout() {
      Object.assign(parentP.style, {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '4px',
        flexDirection: 'row'
      });

      imgsInP.forEach(image => {
        image.style.width = '33.333%';
        image.style.height = 'auto';
      });
    }

    function mobileLayout() {
      Object.assign(parentP.style, {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        alignItems: 'center'
      });

      imgsInP.forEach(image => {
        image.style.width = '100%';
        image.style.height = 'auto';
      });
    }

    function update() {
      if (window.innerWidth < 768) mobileLayout();
      else desktopLayout();
    }

    update();
    window.addEventListener('resize', update);
  });



  // -----------------------------------------
  // 🌟 處理 1 張圖片的 <p>
  // -----------------------------------------
  oneImages.forEach(img => {
    const parentP = img.closest('p');
    if (!parentP) return;

    img.style.width = '100%';
    img.style.height = 'auto';
  });

});



document.addEventListener('DOMContentLoaded', function () {
    const article = document.querySelector('.article-template');
    if (!article) return;

    const paragraphs = article.querySelectorAll('p');

    paragraphs.forEach(p => {
      if (p.querySelector('span')) {
        p.style.textAlign = 'justify';
      }
    });
  });


// 完整版：只保留 Auto (refresh) + USD，下拉每次打開都生效
function filterCurrencyDropdown() {
  const items = document.querySelectorAll('.currency-converter-chooser-item');
  items.forEach(item => {
    const codeMatch = item.className.match(/cbb-currency-code-([A-Z]+)/);
    if (codeMatch) {
      const currency = codeMatch[1];
      // 保留 Auto(refresh) 與 USD，其他隱藏
      if(currency !== 'refresh' && currency !== 'USD') {
        item.style.display = 'none';
      } else {
        item.style.display = 'list-item'; // 確保保留的幣別顯示
      }
    }
  });
}

// 因為 Currency Converter 下拉是動態生成的，所以監聽整個 document 的點擊事件
document.addEventListener('click', function(e) {
  if(e.target.closest('.currency-converter-amount-box')) {
    setTimeout(filterCurrencyDropdown, 50); // 等待下拉生成後執行
  }
});

// 再加一個 MutationObserver，確保下拉更新時也會套用
const observer = new MutationObserver(filterCurrencyDropdown);
const dropdownContainer = document.querySelector('body'); // 監聽整個 body
observer.observe(dropdownContainer, { childList: true, subtree: true });

function formatTWDDecimals() {
  const currencyBtn = document.querySelector('.currency-converter-currency-button-text');

  if (!currencyBtn) return;

  const currentCurrency = currencyBtn.textContent.trim();

  // 只在 TWD 時處理
  if (currentCurrency === 'TWD') {
    const prices = document.querySelectorAll('.cbb-price-digits');

    prices.forEach(el => {
      if (el.textContent.includes('.00')) {
        el.textContent = el.textContent.replace('.00', '');
      }
    });
  }
}

// 初始
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(formatTWDDecimals, 200);
});

// 點擊切換幣別時再跑
document.addEventListener('click', function(e) {
  if (e.target.closest('.currency-converter-amount-box') || 
      e.target.closest('.currency-converter-chooser-item')) {
    setTimeout(formatTWDDecimals, 200);
  }
});

// product 頁面 pagination 換 load more
(() => {
    const initializeLoadMore = () => {
      const button = document.getElementById('LoadMoreButton');

      if (!button || button.dataset.initialized === 'true') return;

      button.dataset.initialized = 'true';

      button.addEventListener('click', async () => {
        const nextUrl = button.dataset.nextUrl;

        if (!nextUrl || button.disabled) return;

        const originalText = button.textContent;

        button.disabled = true;
        button.textContent = 'Loading...';

        try {
          const response = await fetch(nextUrl);

          if (!response.ok) {
            throw new Error(`Request failed: ${response.status}`);
          }

          const html = await response.text();
          const parser = new DOMParser();
          const nextDocument = parser.parseFromString(html, 'text/html');

          const currentGrid = document.getElementById('product-grid');
          const nextGrid = nextDocument.getElementById('product-grid');

          if (!currentGrid || !nextGrid) {
            throw new Error('Product grid not found');
          }

          const newProducts = Array.from(
            nextGrid.querySelectorAll(':scope > .grid__item')
          );

          newProducts.forEach((product) => {
            currentGrid.appendChild(product);
          });

          const nextButton =
            nextDocument.getElementById('LoadMoreButton');

          const currentCount = document.getElementById('LoadMoreCurrent');
          const totalCount = document.getElementById('LoadMoreTotal');
          const progressBar = document.getElementById(
            'LoadMoreProgressBar'
          );

          const loadedProducts =
            currentGrid.querySelectorAll(':scope > .grid__item').length;

          const totalProducts = Number(totalCount?.textContent) || loadedProducts;

          if (currentCount) {
            currentCount.textContent = loadedProducts;
          }

          if (progressBar) {
            progressBar.style.width = `${Math.min(
              (loadedProducts / totalProducts) * 100,
              100
            )}%`;
          }

          if (nextButton?.dataset.nextUrl) {
            button.dataset.nextUrl = nextButton.dataset.nextUrl;
            button.disabled = false;
            button.textContent = originalText;
          } else {
            button.remove();
          }
        } catch (error) {
          console.error('Load more error:', error);

          button.disabled = false;
          button.textContent = 'Try again';
        }
      });
    };

    document.addEventListener('DOMContentLoaded', initializeLoadMore);
    document.addEventListener('shopify:section:load', initializeLoadMore);
  })();